<template>
  <div class="fixed inset-0 bg-gray-200 grid grid-rows-auto-1 z-50">
    <div class="p-4 w-full text-right">
      <wd-button transparent @input="emitClose">
        <icon name="Close" />
      </wd-button>
    </div>
    <div class="p-8 h-full grid items-center -mt-8">
      <div>
        <div class="text-center mb-6">
          <icon name="Help" size="2.5em" />
        </div>
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Help",
  data() {
    return {};
  },
  props: {},
  components: {},
  methods: {
    emitClose() {
      this.$emit("close");
    }
  },
  computed: {},
  created() {}
};
</script>